import {Component, OnInit, Input} from '@angular/core';
import {TranslatableString} from '../../../../models/TranslatableString';

@Component({
  selector: 'app-news-content',
  templateUrl: './news-content.component.html',
  styleUrls: ['./news-content.component.scss']
})
export class NewsContentComponent {
  
  @Input() news: {
    pictureUrl: string,
    title: TranslatableString,
    description: TranslatableString,
    date: string,
    link: string
  };
  
}
